// src/routes/KaafiPayRoutes.js
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import OfficePosters from '../pages/portal/OfficePosters';
 

const PortalRoutes = () => {
  return (
    <Routes>
      <Route path="/office-posters" element={<OfficePosters />} />
    </Routes>
  );
};

export default PortalRoutes;
